import { TwoColumnLayout } from 'layouts';
import type { Event } from 'models';
import { CommentsWrapperSocialEvent } from 'features/feed';
import { EventDetailDescription, EventDetailVideoRecording } from '../../components';
import { EventFeedback, type EventFeedbackOptions } from '../../event-feedback';
import { EventActionsWrapper } from '../event-actions-wrapper';
import { EventChannel } from '../event-channel';
import { EventDetailAttachments } from '../event-detail-attachments';
import { EventDetailCountdownWrapper } from '../event-detail-countdown-wrapper';
import { EventDetailInviteesWrapper } from '../event-detail-invitees-wrapper';
import { EventDetailsCard } from '../event-details-card';

type P = {
  event: Event;
  feedbackOptions: EventFeedbackOptions;
};

const EventDetailDefault = ({ event, feedbackOptions }: P) => {
  const { html, id, medicalGroupName, recording, startTime } = event;

  return (
    <TwoColumnLayout
      left={
        <>
          <EventFeedback {...feedbackOptions} />
          <EventActionsWrapper event={event} />
          <EventDetailDescription eventId={id} htmlContent={html} />
          <EventDetailVideoRecording src={recording?.url} status={recording?.status} />
          <CommentsWrapperSocialEvent card eventId={id} eventType={event.type} />
        </>
      }
      right={
        <>
          <EventDetailCountdownWrapper eventType={event.type} startTime={startTime} />
          <EventDetailInviteesWrapper event={event} />
          <EventDetailAttachments event={event} />
          <EventChannel event={event} />
          {medicalGroupName ? <EventDetailsCard medicalGroupName={medicalGroupName} /> : null}
        </>
      }
    />
  );
};

export default EventDetailDefault;
